// extracted by mini-css-extract-plugin
module.exports = {"circle":"ColorShape_circle__QUM1x","square":"ColorShape_square__2rHdO"};